
export const Constant = {
    data() {
        return {
            AttributeCoefficient: {
                // 会心
                criticalStrike: 9.985,
                // 破防
                overcomeRate: 11.412,
                // 无双
                atStrainRate: 6.734,
                // 会效
                criticalDamagePowerRate: 3.679,
                // 加速
                atHasteRate: 10.610,
            },
            constant: {
                // 等级
                level: 130,
                levelConstant: 130350,
                levelCoefficient: 1155,
                // 体质生命转换率
                vitalityMaxLifeRate: 10,
                // 会心百分比转换率
                criticalStrikeRate: 78622.5,
                // 破防百分比转换率
                overcomeRate: 78622.5,
                // 无双百分比转换率
                atStrainRate: 75809.25,
                // 会效百分比转换率
                criticalDamagePowerRate: 27513.75,
                // 加速百分比转换率
                atHasteRate: 27513.75,
                // 基础会效
                criticalDamagePowerRateBase: 175.00,
                // 全能转无双
                atPVXAllRoundToStrain: 1.5,
                // 全能转破招
                atPVXAllRoundToSurplus: 0.5,
                // 力道转攻击
                strengthToAtPhysicsAttackPower: 0.163,
                // 力道转破防
                strengthToAtPhysicsOvercome: 0.3,
                // 身法转会心
                agilityToAtPhysicsCriticalStrike: 0.9,
                // 双会套装技能id （旧）
                criticalStrikeSkillId: "22896-2",
                // 双会套装id （新）
                criticalStrikeSetId: 6274,
                // 技能增强ID
                skillAdditionList: ["5037"],
                // 腰坠特效
                fengTXSkillId: "38578" ,
                // 水特效
                shuiTXSkillId: "4877",
                // 橙武
                cwTXSkillIdList: ["25784-1"],
                // 麒王逐魂
                qwzhSkillIdList: ["36726-1","36726-2"],
                web: {
                    // 拉满配装
                    enchant: {
                        cap: 12393,
                        clothing: 12392,
                        wrister: 12391,
                        shoe: 12390,
                        waistband: 12389,
                    },
                },
                peiZhuang:{
                    filter:{
                        // 可见装备的最大和最小等级
                        minLevel: 12000,
                        maxLevel: 35000,
                    }
                }
            }
        }
    },
    mounted() {
        // 初始化每个属性的转化率
        this.constant.criticalStrikeRate = this.computeCoefficient(this.AttributeCoefficient.criticalStrike);
        this.constant.overcomeRate = this.computeCoefficient(this.AttributeCoefficient.overcomeRate);
        this.constant.atStrainRate = this.computeCoefficient(this.AttributeCoefficient.atStrainRate);
        this.constant.criticalDamagePowerRate = this.computeCoefficient(this.AttributeCoefficient.criticalDamagePowerRate);
        this.constant.atHasteRate = this.computeCoefficient(this.AttributeCoefficient.atHasteRate);
    },
    methods: {
        // 计算转化率
        computeCoefficient(attribute) {
            return (this.constant.levelCoefficient * this.constant.level - this.constant.levelConstant) * attribute;
        }
    }

}
